module.exports = __webpack_public_path__ + "img/blackshepherdsfinal_dusseldorf.115387cc.jpg";